import { render, staticRenderFns } from "./PlantAvatar.vue?vue&type=template&id=336c6a1a&scoped=true"
import script from "./PlantAvatar.vue?vue&type=script&lang=ts"
export * from "./PlantAvatar.vue?vue&type=script&lang=ts"
import style0 from "./PlantAvatar.vue?vue&type=style&index=0&id=336c6a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c6a1a",
  null
  
)

export default component.exports